import React, { useEffect } from "react";
import Non from "../src/assets/images/Credit/non.jpg";
import Jate from "../src/assets/images/Credit/jate.jpg";
import Mean from "../src/assets/images/Credit/mean.jpg";
import Opec from "../src/assets/images/Credit/opec.jpg";
import Pang from "../src/assets/images/Credit/pang.jpg";
import Bomb from "../src/assets/images/Credit/bombay2025.png";
import Puinoon from "../src/assets/images/Credit/puinoon.jpg";
import { useSelector } from "react-redux";
import { State } from "./reducer";

const TeamCredit = () => {
  const user = useSelector((state: State) => state.user);

  useEffect(() => {
    // Load Instagram embed script
    const existingScript = document.querySelector('script[src="//www.instagram.com/embed.js"]');

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = '//www.instagram.com/embed.js';
      script.async = true;
      document.body.appendChild(script);

      // Cleanup
      return () => {
        const scriptToRemove = document.querySelector('script[src="//www.instagram.com/embed.js"]');
        if (scriptToRemove) {
          document.body.removeChild(scriptToRemove);
        }
      };
    }
  }, []);

  const MemberOfAvengerTeam = [
    {
      id: "pobthon",
      name: "Shark Bomb",
      picture: Bomb,
      position: "Well-known Investor",
      quote: "Investing in the future of coffee",
      role: "Investor",
      instagram: "https://www.instagram.com/bombay.p789?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
    },
    {
      id: "pang",
      name: "Shark Pang",
      picture: Pang,
      position: "Well-known Investor",
      quote: "Building bridges between ideas and reality",
      role: "Investor",
    },
    {
      id: "non",
      name: "Non",
      picture: Non,
      position: "Back-end and Jungle",
      quote: "Coffee or Tea or Me ?",
      role: "Backend Dev",
    },
    {
      id: "jate",
      name: "Jate",
      picture: Jate,
      position: "Quality Assurance and Mage",
      quote: "มองหน้าทำเฉย ระวังเป็นลูกเขยแม่เรานะ",
      role: "QA Engineer",
      instagram: "https://www.instagram.com/jatethanit?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
    },
    {
      id: "mean",
      name: "Mean",
      picture: Mean,
      position: "DevOps and Carry",
      quote: "ที่บ้านเธอมีแก้วกี่ใบ เราจะได้เทใจให้หมดเลย",
      role: "DevOps",
      instagram: "https://www.instagram.com/ace_cinderellaa?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
    },
    {
      id: "opec",
      name: "Opec",
      picture: Opec,
      position: "Front-end and Tank",
      quote: "Coffee is my favorite co-worker",
      role: "Frontend Dev",
    },
    {
      id: "puinoon",
      name: "Puinoon",
      picture: Puinoon,
      position: "UX/UI Designer (Intern 2022👀)",
      quote: "ทําแล้ว ทําอยู่ ทําต่อ 55555(หมายถึงสั่งมัตจะ)",
      role: "UX/UI Designer",
      instagram: "https://www.instagram.com/pn.natpicha_",
    },
  ];

  const TeamCard = ({ member }: any) => {
    const randomTags = [
      "Coffee Lover", "Caffeine Addict", "Tea Drinker", "Bug Hunter",
      "Pixel Perfect", "Code Ninja", "Night Owl", "Early Bird",
      "Cat Lover", "Dog Person", "Foodie", "Gamer", "Sleepy Head",
      "Woxa Fan", "Matcha Lover", "Cocoa Addict", "Milk Tea Lover"
    ];

    // Use member name to pick a stable random tag
    const tagIndex = member.name.split("").reduce((acc: number, char: string) => acc + char.charCodeAt(0), 0) % randomTags.length;
    const randomTag = randomTags[tagIndex];

    return (
      <div className="text-center group relative">
        {/* Profile picture with creative effects */}
        <div className="mb-6 relative">
          <div className="relative inline-block">
            {/* Animated background circle */}
            <div className="absolute inset-0 w-[128px] h-[128px] rounded-full bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 opacity-0 group-hover:opacity-20 transition-opacity duration-500 animate-pulse"></div>

            {/* Profile image */}
            <img
              alt={member.name}
              src={member.picture}
              className="w-[128px] h-[128px] rounded-full object-cover object-center mx-auto relative z-10 border-4 border-white shadow-lg group-hover:scale-110 transition-transform duration-300"
            />

            {/* Floating emoji indicator */}
            <div className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center text-lg opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:rotate-12">
              {member.role === 'Investor' ? '💰' : member.role === 'Backend Dev' ? '🌳' : member.role === 'QA Engineer' ? '🧙‍♂️' : member.role === 'DevOps' ? '⚔️' : member.role === 'Frontend Dev' ? '🛡️' : '☕'}
            </div>
          </div>
        </div>

        {/* Name with creative styling */}
        <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors duration-300">
          {member.name}
        </h3>

        {/* Role/Position with gradient text */}
        <p className="text-blue-600 font-medium mb-4 text-sm uppercase tracking-wide">
          {member.position}
        </p>

        {/* Quote/Bio with creative reveal */}
        <div className="relative overflow-hidden">
          <p className="text-gray-600 text-sm leading-relaxed transform translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
            "{member.quote}"
          </p>

          {/* Decorative line */}
          <div className="w-12 h-0.5 bg-gradient-to-r from-blue-400 to-purple-500 mx-auto mt-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
        </div>

        {/* Creative stats badges */}
        <div className="mt-4 flex justify-center gap-2 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0">

          <span className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full font-medium">
            {randomTag}
          </span>
        </div>

        {/* Instagram link */}
        {member.instagram && (
          <div className="mt-4 flex justify-center opacity-0 group-hover:opacity-100 transition-all duration-500">
            <a
              href={member.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-110"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
              <span className="text-sm font-medium">Follow on Instagram</span>
            </a>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 relative overflow-hidden">
      {/* Creative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200/30 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-200/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: "1s" }}></div>
        <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-pink-200/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: "2s" }}></div>
      </div>

      {/* Main content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-16">
        {/* Header section with creative styling */}
        <div className="text-center mb-16">
          {/* Decorative elements */}
          <div className="flex justify-center mb-6">
            <div className="flex gap-2">
              <div className="w-3 h-3 bg-blue-400 rounded-full animate-bounce"></div>
              <div className="w-3 h-3 bg-purple-400 rounded-full animate-bounce" style={{ animationDelay: "0.1s" }}></div>
              <div className="w-3 h-3 bg-pink-400 rounded-full animate-bounce" style={{ animationDelay: "0.2s" }}></div>
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold mb-6 relative">
            <span className="bg-gradient-to-r from-gray-800 via-blue-600 to-purple-600 bg-clip-text text-transparent">
              Let's Meet Our Team
            </span>
            {/* Decorative underline */}
            <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full"></div>
          </h1>



          {/* Creative stats */}
          <div className="mt-8 flex justify-center gap-6">
            <div className="px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full border border-gray-200 shadow-lg">
              <span className="text-gray-800 font-semibold text-sm">Coffee Powered</span>
            </div>
            <div className="px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full border border-gray-200 shadow-lg">
              <span className="text-gray-800 font-semibold text-sm">Creative Team</span>
            </div>
          </div>
        </div>

        {/* Team grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-16">
          {MemberOfAvengerTeam.map((member) => (
            <TeamCard key={member.id} member={member} />
          ))}
        </div>

        {/* Instagram Feed Section */}
        <div className="mb-16">
          <div className="text-center mb-8">
            <div className="flex justify-center mb-4">
              <div className="flex gap-2">
                <span className="text-2xl">📸</span>
                <span className="text-2xl">✨</span>
                <span className="text-2xl">📱</span>
              </div>
            </div>
            <h2 className="text-3xl font-bold mb-4">
              <span className="bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 bg-clip-text text-transparent">
                Follow Us on Instagram
              </span>
            </h2>
          </div>

          {/* Instagram Feed Embed Container */}
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
            {/* Header */}
            <div className="p-6 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 text-white">
                  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                  <div>
                    <p className="font-bold text-lg">@bombay.p789</p>
                  </div>
                </div>
                <a
                  href="https://www.instagram.com/bombay.p789?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white text-pink-600 px-4 py-2 rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 font-medium text-sm"
                >
                  Follow
                </a>
              </div>
            </div>

            {/* Instagram Profile Widget */}
            <div className="p-6">
              <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-lg overflow-hidden">
                {/* Instagram Embed Container */}
                <div className="w-full max-w-2xl mx-auto">
                  <blockquote
                    className="instagram-media"
                    data-instgrm-permalink="https://www.instagram.com/bombay.p789/"
                    data-instgrm-version="14"
                    style={{
                      background: '#FFF',
                      border: '0',
                      borderRadius: '8px',
                      margin: '0 auto',
                      width: '100%'
                    }}
                  >
                    <div style={{ padding: '16px' }}>
                      <a
                        href="https://www.instagram.com/bombay.p789/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '12px',
                          textDecoration: 'none',
                          color: 'inherit'
                        }}
                      >
                        <img
                          src={Bomb}
                          alt="Instagram Profile"
                          className="w-16 h-16 rounded-full shadow-md border-2 border-white"
                          style={{ flexShrink: 0 }}
                        />
                        <div>
                          <p style={{ fontSize: '14px', fontWeight: 600, margin: 0, color: '#000' }}>bombay.p789</p>
                          <p style={{ fontSize: '12px', margin: 0, color: '#666' }}>View this profile on Instagram</p>
                        </div>
                      </a>
                      <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #eee' }}>
                        <a
                          href="https://www.instagram.com/bombay.p789?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 font-medium w-full"
                          style={{ textDecoration: 'none' }}
                        >
                          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                          </svg>
                          <span>Follow on Instagram</span>
                        </a>
                      </div>
                    </div>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>

          {/* Jate Instagram Feed */}
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden mt-8">
            {/* Header */}
            <div className="p-6 bg-gradient-to-r from-purple-500 via-blue-500 to-cyan-500">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 text-white">
                  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                  <div>
                    <p className="font-bold text-lg">@jatethanit</p>
                  </div>
                </div>
                <a
                  href="https://www.instagram.com/jatethanit?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white text-purple-600 px-4 py-2 rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 font-medium text-sm"
                >
                  Follow
                </a>
              </div>
            </div>

            {/* Instagram Profile Widget */}
            <div className="p-6">
              <div className="bg-gradient-to-br from-purple-50 to-cyan-50 rounded-lg overflow-hidden">
                {/* Instagram Embed Container */}
                <div className="w-full max-w-2xl mx-auto">
                  <blockquote
                    className="instagram-media"
                    data-instgrm-permalink="https://www.instagram.com/jatethanit/"
                    data-instgrm-version="14"
                    style={{
                      background: '#FFF',
                      border: '0',
                      borderRadius: '8px',
                      margin: '0 auto',
                      width: '100%'
                    }}
                  >
                    <div style={{ padding: '16px' }}>
                      <a
                        href="https://www.instagram.com/jatethanit/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '12px',
                          textDecoration: 'none',
                          color: 'inherit'
                        }}
                      >
                        <img
                          src={Jate}
                          alt="Instagram Profile"
                          className="w-16 h-16 rounded-full shadow-md border-2 border-white"
                          style={{ flexShrink: 0 }}
                        />
                        <div>
                          <p style={{ fontSize: '14px', fontWeight: 600, margin: 0, color: '#000' }}>jatethanit</p>
                          <p style={{ fontSize: '12px', margin: 0, color: '#666' }}>View this profile on Instagram</p>
                        </div>
                      </a>
                      <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #eee' }}>
                        <a
                          href="https://www.instagram.com/jatethanit?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-500 to-cyan-500 text-white rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 font-medium w-full"
                          style={{ textDecoration: 'none' }}
                        >
                          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                          </svg>
                          <span>Follow on Instagram</span>
                        </a>
                      </div>
                    </div>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>

          {/* Mean Instagram Feed */}
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden mt-8">
            {/* Header */}
            <div className="p-6 bg-gradient-to-r from-cyan-500 via-green-500 to-emerald-500">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 text-white">
                  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                  <div>
                    <p className="font-bold text-lg">@ace_cinderellaa</p>
                    <p className="text-sm text-cyan-100">Join our community</p>
                  </div>
                </div>
                <a
                  href="https://www.instagram.com/ace_cinderellaa?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white text-cyan-600 px-4 py-2 rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 font-medium text-sm"
                >
                  Follow
                </a>
              </div>
            </div>

            {/* Instagram Profile Widget */}
            <div className="p-6">
              <div className="bg-gradient-to-br from-cyan-50 to-emerald-50 rounded-lg overflow-hidden">
                {/* Instagram Embed Container */}
                <div className="w-full max-w-2xl mx-auto">
                  <blockquote
                    className="instagram-media"
                    data-instgrm-permalink="https://www.instagram.com/ace_cinderellaa/"
                    data-instgrm-version="14"
                    style={{
                      background: '#FFF',
                      border: '0',
                      borderRadius: '8px',
                      margin: '0 auto',
                      width: '100%'
                    }}
                  >
                    <div style={{ padding: '16px' }}>
                      <a
                        href="https://www.instagram.com/ace_cinderellaa/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '12px',
                          textDecoration: 'none',
                          color: 'inherit'
                        }}
                      >
                        <img
                          src={Mean}
                          alt="Instagram Profile"
                          className="w-16 h-16 rounded-full shadow-md border-2 border-white"
                          style={{ flexShrink: 0 }}
                        />
                        <div>
                          <p style={{ fontSize: '14px', fontWeight: 600, margin: 0, color: '#000' }}>ace_cinderellaa</p>
                          <p style={{ fontSize: '12px', margin: 0, color: '#666' }}>View this profile on Instagram</p>
                        </div>
                      </a>
                      <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #eee' }}>
                        <a
                          href="https://www.instagram.com/ace_cinderellaa?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-cyan-500 to-emerald-500 text-white rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 font-medium w-full"
                          style={{ textDecoration: 'none' }}
                        >
                          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                          </svg>
                          <span>Follow on Instagram</span>
                        </a>
                      </div>
                    </div>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>


          {/* Puinoon Instagram Feed */}
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden mt-8">
            {/* Header */}
            <div className="p-6 bg-gradient-to-r from-rose-400 via-fuchsia-500 to-indigo-500">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 text-white">
                  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                  <div>
                    <p className="font-bold text-lg">@pn.natpicha_</p>
                    <p className="text-sm text-rose-100">UX/UI Designer</p>
                  </div>
                </div>
                <a
                  href="https://www.instagram.com/pn.natpicha_?utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white text-rose-600 px-4 py-2 rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 font-medium text-sm"
                >
                  Follow
                </a>
              </div>
            </div>

            {/* Instagram Profile Widget */}
            <div className="p-6">
              <div className="bg-gradient-to-br from-cyan-50 to-emerald-50 rounded-lg overflow-hidden">
                {/* Instagram Embed Container */}
                <div className="w-full max-w-2xl mx-auto">
                  <blockquote
                    className="instagram-media"
                    data-instgrm-permalink="https://www.instagram.com/pn.natpicha_?utm_source=qr"
                    data-instgrm-version="14"
                    style={{
                      background: '#FFF',
                      border: '0',
                      borderRadius: '8px',
                      margin: '0 auto',
                      width: '100%'
                    }}
                  >
                    <div style={{ padding: '16px' }}>
                      <a
                        href="https://www.instagram.com/pn.natpicha_/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '12px',
                          textDecoration: 'none',
                          color: 'inherit'
                        }}
                      >
                        <img
                          src={Puinoon}
                          alt="Instagram Profile"
                          className="w-16 h-16 rounded-full shadow-md border-2 border-white"
                          style={{ flexShrink: 0 }}
                        />
                        <div>
                          <p style={{ fontSize: '14px', fontWeight: 600, margin: 0, color: '#000' }}>pn.natpicha_</p>
                          <p style={{ fontSize: '12px', margin: 0, color: '#666' }}>View this profile on Instagram</p>
                        </div>
                      </a>
                      <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #eee' }}>
                        <a
                          href="https://www.instagram.com/pn.natpicha_?utm_source=qr"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-rose-500 to-indigo-500 text-white rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 font-medium w-full"
                          style={{ textDecoration: 'none' }}
                        >
                          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                          </svg>
                          <span>Follow on Instagram</span>
                        </a>
                      </div>
                    </div>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Wrapped Portal Button */}
        {/* <div className="text-center mb-8">
          <button
            onClick={() => navigate("/wrapped")}
            className="relative group inline-block"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full blur opacity-75 group-hover:opacity-100 transition-opacity duration-300 animate-pulse"></div>
            <div className="relative bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-8 py-3 rounded-full hover:scale-105 transition-transform duration-300 shadow-xl flex items-center gap-2 font-bold text-lg">
              <span className="text-2xl">🎁</span>
              <span>Open My Wrapped 2025</span>
              <span className="text-2xl">✨</span>
            </div>
          </button>
        </div> */}

        {/* Back button with creative styling */}
        <div className="text-center">
          <a
            href={user.role === "admin" ? "/statusOrder-admin" : "/statusOrder"}
            className="inline-block relative group"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-gray-800 to-blue-600 rounded-lg blur opacity-0 group-hover:opacity-75 transition-opacity duration-300"></div>
            <div className="relative bg-gray-800 text-white px-8 py-3 rounded-lg hover:bg-blue-600 transition-all duration-300 transform group-hover:scale-105 group-hover:-translate-y-1 shadow-lg group-hover:shadow-xl">
              <span className="flex items-center gap-2">
                <span className="text-lg">←</span>
                <span className="font-medium">Back to Orders</span>
                <span className="text-sm opacity-70 group-hover:opacity-100 transition-opacity">☕</span>
              </span>
            </div>
          </a>
        </div>

        {/* Creative footer */}
        <div className="text-center mt-16 pb-8">
          <div className="flex justify-center gap-4 mb-4">
            <span className="text-2xl animate-bounce" style={{ animationDelay: "0s" }}>☕</span>
            <span className="text-2xl animate-bounce" style={{ animationDelay: "0.2s" }}>🍰</span>
            <span className="text-2xl animate-bounce" style={{ animationDelay: "0.4s" }}>🎵</span>
            <span className="text-2xl animate-bounce" style={{ animationDelay: "0.6s" }}>💖</span>
          </div>
          <p className="text-gray-500 text-sm">
            Made with love, coffee, and lots of debugging 🐛
          </p>
        </div>
      </div>
    </div>
  );
};

export default TeamCredit;
